import React from 'react'
import { Route, Routes } from "react-router-dom";
import PublicRoute from './PublicRoute';
import Sidebar from '../layout/Sidebar';
import Home from '../pages/home/Home';
import ListaPacientes from '../pages/pacientes/lista/ListaPacientes';
import CrearPacientes from '../pages/pacientes/crear/CrearPacientes';
import OptometriasNeonatas from '../pages/consultas/optometriasNeonatas/OptometriasNeonatas';
import OptometriasPediatrica from '../pages/consultas/optometriasPediatrica/OptometriasPediatrica';
import OrtopticaVisionBinocular from '../pages/consultas/ortopticaVisionBinocular/OrtopticaVisionBinocular';
import BajaVision from '../pages/consultas/bajaVision/BajaVision';
import OptometriasGeneral from '../pages/consultas/optometriasGeneral/OptometriasGeneral';
import HistoriaClinica from '../pages/consultas/historiaClinica/HistoriaClinica';
import Agenda from '../pages/agenda/Agenda';
import Chat from '../pages/chat/Chat';
import Login from '../pages/auth/login/Login';
import Analytics from '../pages/analytics/Analytics';
import AuthRoute from './AuthRoute';
import ListaUsuarios from '../pages/usuarios/ListaUsuarios';
import ListaSucursales from '../pages/sucursales/ListaSucursales';
import ListaTiposUsuarios from '../components/table/TableComponentTipoUsuarios';
import ListaEmpresas from '../pages/empresas/ListaEmpresas';
import Profile from '../pages/auth/profile/Profile';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route element={<PublicRoute />}>

        <Route path="/login" element={<Login />} />
      </Route>
      <Route element={<AuthRoute />}>
        <Route element={<Sidebar />}>
          <Route path="*" element={<Home />} />
          <Route path="pacientes/crear" element={<CrearPacientes />} />
          <Route path="pacientes/editar/:id" element={<CrearPacientes />} />
          <Route path="/pacientes/lista" element={<ListaPacientes />} />

          <Route path="/administrador/usuarios" element={<ListaUsuarios />} />
          <Route path="/administrador/sucursales" element={<ListaSucursales />} />
          <Route path="/administrador/tipos_usuarios" element={<ListaTiposUsuarios />} />
          <Route path="/administrador/empresas" element={<ListaEmpresas />} />

          {/* Consultas */}
          <Route path="/consultas/optometrias-neonatas" element={<OptometriasNeonatas />} />
          <Route path="/consultas/optometrias-pediatrica" element={<OptometriasPediatrica />} />
          <Route path="/consultas/ortoptica-vision-binocular" element={<OrtopticaVisionBinocular />} />
          <Route path="/consultas/baja-vision" element={<BajaVision />} />
          <Route path="/consultas/optometrias-general" element={<OptometriasGeneral />} />
          <Route path="/consultas/historia-clinica" element={<HistoriaClinica />} />

          {/* AGENDA */}
          <Route path="/agenda" element={<Agenda />} />
          <Route path='/my-profile' element={<Profile/>}/>

          {/* CHAT */}
          <Route path="/chat" element={<Chat />} />

          {/* ANALYTICS */}
          <Route path="/kpis" element={<Analytics />} />
        </Route>
      </Route>

    </Routes>
  )
}

export default AppRoutes